import React ,{useState,useEffect} from 'react';
import Sanavbar from '../Components/Sanavbar';
import Sasidebar from '../Components/Sasidebar';
import SaventuresMain from '../Components/SaventuresMain';
import { Link } from 'react-router-dom';


const Superventures = () => {
    const [sidebar, setSidebarOpen]=useState(false);
    const togglesidebar = ()=> {
      setSidebarOpen((prevState) => !prevState);
    }
    useEffect(()=>{const venture = localStorage.getItem('ventureid');
    if(venture!=='00'){document.getElementById("SA-dashboard").style.display="none"}
    else{ document.getElementById("SA-dashboard").style.display="grid"}
   },[]);

   /*---Once logout then clear localstorage function----*/

function removelocalstorage(){
  localStorage.clear()
  window.location.href='/'
}



/*----Logout form function----*/


function ToggleLogForm()
{
   document.getElementById("modalLogoutForm").style.display = "block";
}


 
function closeForm()
{
   document.getElementById("modalLogoutForm").style.display = "none";
 
 }
      return (
          <div className='super-container' id='SA-dashboard'>
          <Sanavbar sidebar={sidebar} openSidebar={togglesidebar}/>
          <Sasidebar sidebar={sidebar} openLogForm={ToggleLogForm}/>
          <SaventuresMain/>
    

          <div className="Paropop-fade" id="modalLogoutForm" tabindex="-1" role="dialog">
  <div className="modal-dialog" role="document" id="Corpcenterlogoutform">
    <div className="modal-content">
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">LOG OUT</h4>
        <button type="button" className="close" onClick={closeForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

<form id='form'>

   <div className="modal-body mx-3">

        <div className="md-form mb-5">
            <div className='text-center'>
          <h5>Are you sure want to logout?</h5>
          </div>
        </div>

   </div>

      <div className="modal-footer d-flex justify-content-center">
        <Link to="/"><button className="salogout-adduser-button" onClick={removelocalstorage} type='submit'>Confirm</button></Link>
        <button className="salogout-adduser-button" onClick={closeForm} type='submit'>Cancel</button>
      </div>

      </form>
      
    </div>
  </div>
</div>

        </div>
      );
      }
export default Superventures;